import { TimetableVersionClassesMatrix } from '../../../../../../components/TimetableVersion/TimetableVersionDataAvailabilityMatrix/TimetableVersionClassesMatrix';
import { TimetableVersionClassesConditions } from '../../../../../../components/TimetableVersion/TimetableVersionDataConditions/TimetableVersionClassesConditions';
import { TimetableVersionClassesTable } from '../../../../../../components/TimetableVersion/TimetableVersionDataTables/TimetableVersionClassesTable';
import { TimetableVersionImportClassesButton } from '../../../../../../components/TimetableVersion/TimetableVersionImportClasses/TimetableVersionImportClassesButton';
import { hexToColorOption } from '../../../../../../utils/colorUtils';
import { TimetableResourceDataPage, timetableResourceConfig } from '../TimetableResourceDataPage';

const classConfig = timetableResourceConfig({
  availabilityResourceType: 'class',
  relationKey: 'classes',
  lessonFilterColumn: 'classes',
  importLabelKey: 'classes.title',
  selectVersionUuids: (store) => Array.from(store.classes.keys()),
  selectEntities: (basicData) => basicData.classesData?.classes,
  mapRow: (c) => {
    const { html, label } = hexToColorOption(c.timetableConfig?.color ?? '');
    return {
      uuid: c.uuid,
      name: c.name,
      shortName: c.shortName,
      count: 0,
      color: { color: html, colorLabel: label },
    };
  },
  addEntities: (store, entities) => store.addClasses([...entities]),
  removeEntities: (store, uuids) => store.removeClasses(uuids),
  renderMatrix: ({ selected, loading, versionUuid, timeGridEntries, onChange }) => (
    <TimetableVersionClassesMatrix
      selectedUuid={selected?.uuid ?? ''}
      versionUuid={versionUuid}
      timeGridEntries={timeGridEntries}
      loading={loading}
      onChange={onChange}
    />
  ),
  renderTable: ({ versionUuid, versionUuids, search, onRowSelection, onRemove, onShowLessonClick, onImportClick }) => (
    <TimetableVersionClassesTable
      onImportClick={onImportClick}
      onRowSelection={(row) =>
        onRowSelection({ uuid: row.uuid, name: row.name, shortName: row.shortName, count: 0, color: row.color })
      }
      onRemove={onRemove}
      versionClassesUuids={versionUuids}
      versionUuid={versionUuid}
      search={search}
      onShowLessonClick={onShowLessonClick}
    />
  ),
  renderConditions: ({ versionUuid, selected, ...control }) =>
    versionUuid && selected ? (
      <TimetableVersionClassesConditions
        key={selected.uuid}
        versionUuid={versionUuid}
        classUuid={selected.uuid}
        name={selected.name}
        {...control}
      />
    ) : null,
  renderImport: ({ versionUuid, isOpen, onOpenChange }) =>
    versionUuid ? (
      <TimetableVersionImportClassesButton versionUuid={versionUuid} isOpen={isOpen} onOpenChange={onOpenChange} />
    ) : null,
});

export const PlanTimetableClasses = () => <TimetableResourceDataPage config={classConfig} />;
